import React from 'react';
import { FormAsyncMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useLocationsFilter } from './useLocationsFilter';

export const LocationsFilter = ({ value, setFilters, remoteValue }) => {
  const { formSchema, onSearchChange, onSubmit } = useLocationsFilter({
    setFilters,
  });

  // Combine locations and remote into one array for Formik
  const initialLocations = [...(value || [])];
  if (remoteValue === 'remote' && !initialLocations.some((item) => item.value === 'remote')) {
    initialLocations.push({ value: 'remote', label: 'Remote' });
  }

  return (
    <Formik
      initialValues={{ locations: initialLocations }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="locations"
          label="Locations"
          placeholder="Add locations"
          size="small"
          component={FormAsyncMultiSelect}
          loadOptions={onSearchChange}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

LocationsFilter.propTypes = {
  value: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  setFilters: PropTypes.func.isRequired,
  remoteValue: PropTypes.string,
};

LocationsFilter.defaultProps = {
  value: [],
  remoteValue: '',
};
